import { ChannelEntity } from '../../domain/entities/Channel'
import { Channel } from '../../shared/types/Channel'

// API model is currently identical to the shared Channel DTO
export type ChannelAPIModel = Channel

export const mapApiToEntity = (api: ChannelAPIModel): ChannelEntity => {
  return ChannelEntity.create({
    uuid: api.uuid,
    link: api.link,
    title: api.title,
    type: api.type,
    isPrivate: api.isPrivate,
    minimalSendingInterval: api.minimalSendingInterval,
    sendingStartTime: api.sendingStartTime,
    sendingEndTime: api.sendingEndTime,
    category: api.category,
    // ?? 0 — фронт может быть задеплоен раньше бэка, тогда поля в ответе ещё нет
    membersCount: api.membersCount ?? 0,
    rules: api.rules ?? [],
  })
}

export const mapEntityToDTO = (entity: ChannelEntity): Channel => ({
  uuid: entity.uuid,
  link: entity.link,
  title: entity.title,
  type: entity.type,
  isPrivate: entity.isPrivate,
  minimalSendingInterval: entity.minimalSendingInterval,
  sendingStartTime: entity.sendingStartTime,
  sendingEndTime: entity.sendingEndTime,
  category: entity.category,
  membersCount: entity.membersCount,
  rules: entity.rules,
})
